import React, { CSSProperties } from "react";
import clsx from "clsx";
import { TextField } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { UIStyleProps } from "./UIComponents";
import "./UISearchInput.scss";

export type UISearchInputProps = {
	onSearch: (val: string) => any;
	defaultValue?: string;
	placeholder?: string;
	children?: React.ReactNode;
	inputStyle?: CSSProperties;
	noBorder?: boolean;
	autoWidth?: boolean;
} & UIStyleProps;

const UISearchInput: React.FC<UISearchInputProps> = (props: UISearchInputProps) => {
	return (
		<div
			className={clsx(
				"form-row position-relative ui-search-input-container",
				props.className,
				props.noBorder && "no-border",
				!props.autoWidth && "w-100-sm",
				props.autoWidth && "w-auto"
			)}
			style={props.style}
		>
			<TextField
				style={props.inputStyle}
				variant="outlined"
				placeholder={props.placeholder || "Search"}
				defaultValue={props.defaultValue}
				onChange={(e) => {
					props.onSearch(e.target.value);
				}}
			/>
			<SearchIcon
				className={clsx("position-absolute", !props.noBorder && "mt-3")}
				style={{ marginLeft: "15px", marginTop: "1.2rem" }}
				htmlColor={props.noBorder ? "#adb5bd" : undefined}
				fontSize={props.noBorder ? "small" : undefined}
			/>
			{props.children}
		</div>
	);
};

export default UISearchInput;
